/* istanbul ignore file */
import Axios, { Method, ResponseType } from 'axios';
import { getCorrelationId } from '../lib/telemetryUtils';
import Auth from './auth';
const correlationId = getCorrelationId();

export interface HttpRequest {
  url: string;
  apiVersion?: string;
  data?: any;
  contentType?: string;
  accept?: string;
  cacheControl?: string;
  headers?: any;
  responseType?: ResponseType;
  axiosInstance?: any;
  sendAuthToken?: boolean;
}

export interface InternalHttpRequest extends HttpRequest {
  method: Method;
}

const sendRequest = ({
  url,
  method,
  apiVersion,
  data = undefined,
  contentType = 'application/json',
  accept = 'application/json',
  cacheControl = 'no-cache',
  headers = undefined,
  responseType = undefined,
  axiosInstance = undefined,
  sendAuthToken = true,
}: InternalHttpRequest): Promise<any> => {
  const customHeaders = {
    'x-correlation-id': correlationId,
    ...headers,
  };

  if (apiVersion) {
    customHeaders['api-version'] = apiVersion;
  }

  if (contentType) {
    customHeaders['content-type'] = contentType;
  }

  if (accept) {
    customHeaders.accept = accept;
  }

  if (cacheControl) {
    customHeaders['cache-control'] = cacheControl;
  }

  if (sendAuthToken && Auth.isLoggedIn()) {
    customHeaders.Authorization = `Bearer ${Auth.getAccessToken()}`;
  }

  const config = {
    url,
    method,
    data,
    headers: customHeaders,
    responseType,
  };

  return (axiosInstance || Axios).request(config);
};

const get = (request: HttpRequest): Promise<any> => sendRequest({ ...request, method: 'GET' });

const post = (request: HttpRequest): Promise<any> => sendRequest({ ...request, method: 'POST' });

export default {
  sendRequest,
  get,
  post,
};
